/* eslint-disable max-len */
import React from 'react';
import { observer, inject } from 'mobx-react';
import styles from './colorPanel.scss';
import classNames from 'classnames';
import { IVariantStore } from '../../../../types';
import TabNavigationHelper from '../../../../helpers/tabNavigationHelper';
import { CustomSwiper } from '../../customeSwiper/customeSwiper';
import { decodeHTML } from '../../../../helpers/html-helper';

export const ColorPanel = inject('variantStore')(
    observer(({ variantStore }: IVariantStore) => {
        const tabNavigation = TabNavigationHelper.instance;
        let selectedColor = variantStore?.selectedBrickItem.selectedColor;
        const availableColors = variantStore?.sbiVariantSelection?.availableColors;
        const tmpSelectedColorIndex = availableColors?.findIndex(color => {
            return color.code === selectedColor?.code;
        });

        const selectedColorIndex = tmpSelectedColorIndex ? tmpSelectedColorIndex : 0;

        if (variantStore) {
            // eslint-disable-next-line no-console
            // console.log(variantStore.selectedBrickItem.selectedColor);
        }

        // useEffect(() => {
        //     const elem = document.getElementsByClassName('fsp-selected')[0];
        //     window.shell.tabNav.focus(elem)
        // });

        function handleColorClick(event) {
            event.preventDefault();
            event.stopPropagation();
            const target = event.currentTarget as HTMLElement;
            const colorCode = target.dataset.colorcode;
            if (colorCode) {
                const selectedColorInternal = availableColors?.find(
                    availableColor => availableColor.code == parseInt(colorCode)
                );

                if (selectedColorInternal) {
                    selectedColor = { code: selectedColorInternal.code, name: selectedColorInternal.name };
                    variantStore?.changeSelectedColor(selectedColor);
                }
            }
        }

        const selectedColorInternal = availableColors?.find(
            availableColor => availableColor.code == selectedColor?.code
        );

        return (
            <>
                <div role='color_content_wrapper' className={styles.color_content_wrapper}>
                    {!variantStore?.isDeskTopView() && <label className={classNames(styles.chosen_color_label, 'notranslate')}>
                        {variantStore?.mainStore.localization.generalL10n.selection}:{' ' +
                            variantStore?.selectedColor.name}
                    </label>}

                    <div role='color_content' className={styles.color_content}>
                        <div role='color_icons' className={styles.color_icons} ref={(el) => tabNavigation.setGroupAtt(el)}>
                            <CustomSwiper
                                type='color'
                                selectedElementIndex={selectedColorIndex}
                                slidesPerColumn={2}
                                columnsPerView={variantStore?.getColumnsPerView()}
                                enabled={!variantStore?.isDeskTopView()}
                            >
                                {availableColors?.map((availableColor, index) =>
                                (
                                    <a
                                        key={index}
                                        data-testid='flexset-colour_values_icon-layer_2'
                                        data-semantic-id='flexset-colour_values_icon-layer_2'
                                        data-flexset-id={variantStore?.selectedBrickItem.fsCode}
                                        data-flexset-name={variantStore?.mainStore.dataStore.orderModule.flexSetInfo.displayName}
                                        data-flexset-module-layer_0-category={variantStore?.getOMBrickSelection?.mainNavigationKeyPath}
                                        data-flexset-module-layer_0-index={variantStore?.getOMBrickPosition}
                                        data-flexset-module-layer_1-category={variantStore?.selectedBrickItem.mainNavigationKeyPath}
                                        data-flexset-module-layer_1-index={variantStore?.brickItemPosition}
                                        data-flexset-item-name={variantStore?.selectedBrickItem.salesDesignation}
                                        data-flexset-item-sku={variantStore?.mainStore.getSalesArticleNo(availableColor.salesArticleVariantKey)}
                                        className={classNames(styles.color_border, {
                                            'fsp-selected': selectedColorIndex === index,
                                        }, { [styles.kiosk_color_border]: variantStore?.mainStore.showKioskLayout })}
                                        data-colorcode={availableColor.code}
                                        onClick={handleColorClick}
                                        href={variantStore?.getUrlByAvailableColor(availableColor)}
                                        onKeyDown={(e) => {
                                            if (e.key === ' ') {
                                                handleColorClick(e)
                                            }
                                        }}
                                        title={
                                            // variantStore?.mainStore.dataStore.orderModule.articleInfo.title + ' ' +
                                            'fake title' +
                                            availableColor.name}
                                        ref={(el) => tabNavigation.setFocusAtt(el)}
                                    >
                                        <img
                                            className={classNames(styles.color_icon, 'notranslate')}
                                            src={availableColor.iconPath}
                                            title={availableColor.name}
                                            alt={variantStore?.mainStore.localization.generalL10n.colorIcon + ' ' +
                                                availableColor.name}
                                        ></img>
                                    </a>
                                ))}
                            </CustomSwiper>
                        </div>
                        {variantStore?.isDeskTopView() && <label className={classNames(styles.chosen_color_label, 'notranslate')}>
                            {variantStore?.mainStore.localization.generalL10n.selection}:{' ' +
                                variantStore?.selectedColor.name}
                        </label>}
                        <>
                            <hr />
                            <div className={styles.image_content}>
                                <img
                                    data-testid='side_image' data-semantic-id='side_image'
                                    className={styles.side_image}
                                    src={variantStore?.sideImagePath}
                                />
                            </div>
                        </>
                        <button className={styles.details_btn}
                            data-testid='flexset-button-layer_2-details' data-semantic-id='flexset-button-layer_2-details'
                            data-flexset-id={variantStore?.selectedBrickItem.fsCode}
                            data-flexset-name={variantStore?.mainStore.dataStore.orderModule.flexSetInfo.displayName}
                            data-flexset-module-layer_0-category={variantStore?.getOMBrickSelection?.mainNavigationKeyPath}
                            data-flexset-module-layer_0-index={variantStore?.getOMBrickPosition}
                            data-flexset-module-layer_1-category={variantStore?.selectedBrickItem.mainNavigationKeyPath}
                            data-flexset-module-layer_1-index={variantStore?.brickItemPosition}
                            data-flexset-item-name={variantStore?.selectedBrickItem.salesDesignation}
                            data-flexset-item-sku={variantStore?.mainStore.getSalesArticleNo(selectedColorInternal?.salesArticleVariantKey)}
                            onClick={() => {
                                variantStore?.mainStore.productInfoStore.setItemOrigin('FlexSets-2');
                                variantStore?.setDetailsModalOpen(true);
                            }}
                            ref={(el) => tabNavigation.setFocusAtt(el)}>
                            <span className={styles.d_btn_text}>
                                {decodeHTML(variantStore?.mainStore?.localization?.generalL10n?.details || '')}
                            </span>
                        </button>
                    </div>
                </div>
            </>
        );
    })
);

